export default __webpack_public_path__ + "9cb4a996951c322981967e28de25da83.woff2";